import * as React from 'react';
import { Spin } from 'antd';
import Screen from '../../../Components/Screen';

export default () => (
  <Screen>
    <div style={{ textAlign: 'center', padding: 100 }}>
      <Spin size="large" />
    </div>
  </Screen>
);
